import { render, staticRenderFns } from "./ListCommunes.vue?vue&type=template&id=d6559d28&lang=pug"
import script from "./ListCommunes.vue?vue&type=script&lang=js"
export * from "./ListCommunes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports